import { render, staticRenderFns } from "./GpzNavLeft.vue?vue&type=template&id=495ab4b8&scoped=true"
import script from "./GpzNavLeft.vue?vue&type=script&lang=js"
export * from "./GpzNavLeft.vue?vue&type=script&lang=js"
import style0 from "./GpzNavLeft.vue?vue&type=style&index=0&id=495ab4b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495ab4b8",
  null
  
)

export default component.exports